import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import RegimeDataTable from "./RegimeDataTable"
import { EditRegimeModal } from "./EditRegimeModal";
import server from "../../../utils/serverConfig";

export default function RegimeData() {

  const [regimeData, setRegimeData] = useState([]);

  const fetchRegimeData = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}regime`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Regime data",response.data);
        setRegimeData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => { 
    fetchRegimeData();
  }, []);


  return (
    <div className="flex flex-col relative  w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4 ">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            Regime Data Table
          </p>

          <EditRegimeModal fetchRegimeData={fetchRegimeData} />
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">
        <div className="flex min-w-full pt-2">
          <RegimeDataTable regimeData={regimeData} />
        </div>
      </div>
    </div>
  );
}
